module.exports = __webpack_public_path__ + "static/media/pdf.be0a77b4.svg";